/**
 * Expected response body for GET inventory
 */
export interface InventoryGetDataBase {
  error: string
  message: string
  status: string
  body: {
    count: number
    offset: number
    data: InventoryItem[]
  }
}
export interface FulfillmentGetDataBase {
  error: string
  message: string
  status: string
  body: {
    count: number
    offset: number
    data: FulfillmentItem[]
  }
}

export interface InventoryItem {
  iccid: string
  matchingId: string
  qrCode: string
  smdpAddress: string
  userId: string
  userName: string
  userEmail: string
  status: string
  telnaStatus: string
  provisionedAt: Date
}
export interface OldInventoryItem {
  CreatedAt: string
  DeletedAt?: string
  ID: string
  Packages?: object[] // TODO: type this
  UpdatedAt: string
  created_by: string
  ICCID: string
  MatchingID: string
  QRCode: string
  ICCIDStatus: string
  SMDPAddress: string
  PlanStatus: string
  updated_by: string
  UserEmail: string
  UserName: string
  PackageID: string
  PackageTypeID: string
  ActiveStartAt: string
  ActiveEndAt: string
  PlanName: string
  PurchaseAt: string
  Price: string
}

export interface FulfillmentDisplayItem {
  ID: string
  userEmail: string
  firstName: string
  lastName: string
}
export interface FulfillmentItem {
  ID: string
  userEmail: string
  firstName: string
  lastName: string
  CreatedAt: string
  UpdatedAt: string
  createdBy: string
  updatedBy: string
}

export interface FulfillmentCSV {
  firstName: string
  lastName: string
  userEmail: string
  countryCode: string
  mobileNo: string
}

/* List of possible inventory status */
export enum InventoryStatus {
  PROVISIONED = 'PROVISIONED',
  AVAILABLE = 'AVAILABLE',
  TERMINATED = 'TERMINATED'
}

export interface EsimCountType {
  status: InventoryStatus
  count: string
}

export interface EsimDataType {
  iccid: string
  matchingId: string
  qrCode: string
  smdpAddress: string
  status: InventoryStatus
  telnaStatus: string
  provisionedAt: string
  userId: string
  userName: string
  userEmail: string
}

export interface EsimInventoryTypeV2 {
  status: string
  data: {
    esimsCount: EsimCountType[]
    esimsData: EsimDataType[]
    paginationData: {
      limit: number
      offset: number
      total: number
    }
  }
}
